<template>
	<section class="margin-layout">
		<template v-if="isEdit">
			<compFormEdit :formdata="getDeliver" ref="formdata" v-model="formData"></compFormEdit>
			<vButtonGroup class="text-right">
				<vButton theme="primary" @click="handleConfirmModal">{{$t('global.common.update_OK',{defaultValue:'确定'})}}</vButton>
				<vButton @click="cancel">{{$t('global.common.return',{defaultValue:'返回'})}}</vButton>
			</vButtonGroup>
		</template>
		<compFormQuery v-else :formdata="getDeliver" :value="formData"></compFormQuery>
		<vLoading size="large" transfer :loading="loading"></vLoading>
		<compModal
			v-model="modalProps.show"
			v-bind="modalProps"
			@on-close="modalProps.show=false"
			@on-confirm="confirm"
		>
			<!-- <component
				v-if="modalProps.component"
				:is="modalProps.component"
				v-bind="modalProps"
				v-on="modalProps.on"
			/>-->
		</compModal>
	</section>
</template>

<script>
// import { HttpConfirmShipment, HttpPackageList, HttpChangeShipment } from '@/service/inbound';
import {
    HttpTransferPlanConfirmDelivery
} from "@/service/transferplan";
import mixin from "../mixin";
export default {
	mixins: [mixin],
	props: ['isEdit', 'value', 'needBox','activeid'],
	components: {
		compFormQuery: () => import("@components/templates/formquery"),
		compFormEdit: () => import("@components/templates/formedit"),
		compModal: () => import("@components/templates/modal"),
	},
	data() {
		return {
			formData: {
				ids: []
			},
			loading: false,
			hasBoxData: false,
			modalProps: {
				show: false,
			}
		};
	},
    created () {
        if (typeof this.activeid == 'string') {
            this.formData.ids = this.activeid.split(',');
        }
        else {
            this.formData.ids = this.activeid;
        }
    },
	mounted() {
        console.log(this.isEdit);
		// console.log(!this.isEdit)
		if (!this.isEdit) this.formData = { ...this.formData, ...this.value }
		// console.log(this.formData.actualArriveTime)
		if(this.formData.actualArriveTime){
			let actualArriveTime = this.formData.actualArriveTime.replace('00:00:00','')
			this.$set(this.formData,'actualArriveTime',actualArriveTime)
		}
		// this.getPackageList();
	},
	watch: {
		value: {
			deep: true,
			handler(val) {
				if (!this.isEdit) this.formData = { ...this.formData, ...val };
			}
		}
	},
	computed: {
		//集装箱
		isCarton() {
			return this.formData.goodsType == 2
		},
		// 发运信息
		getDeliver() {
			return [{
				label: this.$t('fbb.inbound.actualdate_shipment',{defaultValue:'实际发运日期'}),
				key: "actualShipDate",
				tag: 'vDatepicker',
				props: {
					format: 'yy-mm-dd',
				},
			}, {
				label: this.$t('fbb.inbound.exped_warehousedate',{defaultValue:'预计入库日期'}),
				key: "estimateArriveTime",
				tag: 'vDatepicker',
				props: {
					format: 'yy-mm-dd',
				},
			}, {
				label: this.$t('fbb.inbound.logistics_singleno',{defaultValue:'物流单号'}),
				key: "tmsNo",
			}, {
				label: this.$t('fbb.inbound.goods_form',{defaultValue:'货物形态'}),
				key: "goodsType",
				tag: 'vSelect',
				options: this.getGoodsType,
			}, ...(this.isCarton ? [{
				label: this.$t('fbb.inbound.gpno_container',{cartonno1:'20GP',defaultValue:'20GP集装箱数量'}),
				key: "gpQuantity20",
				required: false,
				tag: "vInputNumber",
				props: {
					min: 1,
					math: "round"
				}
			}, {
				label: this.$t('fbb.inbound.gp_number',{cartonno2:'20GP',defaultValue:'20GP集装箱号'}),
				key: "gpCartonNo20",
				required: false,
				props: {
					placeholder: this.$t('fbb.inbound.more_containersplit',{defaultValue:'多个集装箱号,分割'})
				}
			}, {
				label: this.$t('fbb.inbound.gpno_container',{cartonno1:'40GP',defaultValue:'40GP集装箱数量'}),
				key: "gpQuantity40",
				tag: "vInputNumber",
				required: false,
				props: {
					min: 1,
					math: "round"
				}
			}, {
				label: this.$t('fbb.inbound.gp_number',{cartonno2:'40GP',defaultValue:'40GP集装箱号'}),
				key: "gpCartonNo40",
				required: false,
				props: {
					placeholder: this.$t('fbb.inbound.more_containersplit',{defaultValue:'多个集装箱号,分割'})
				}
			}, {
				label: this.$t('fbb.inbound.gpno_container',{cartonno1:'40HQ',defaultValue:'40HQ集装箱数量'}),
				key: "hqQuantity40",
				tag: "vInputNumber",
				required: false,
				props: {
					min: 1,
					math: "round"
				}
			}, {
				label: this.$t('fbb.inbound.gp_number',{cartonno2:'40HQ',defaultValue:'40HQ集装箱号'}),
				key: "hqCartonNo40",
				required: false,
				props: {
					placeholder: this.$t('fbb.inbound.more_containersplit',{defaultValue:'多个集装箱号,分割'})
				}
			}, {
				label: this.$t('fbb.inbound.gpno_container',{cartonno1:'45HQ',defaultValue:'45HQ集装箱数量'}),
				key: "hqQuantity45",
				tag: "vInputNumber",
				required: false,
				props: {
					min: 1,
					math: "round"
				}
			}, {
				label: this.$t('fbb.inbound.gp_number',{cartonno2:'45HQ',defaultValue:'45HQ集装箱号'}),
				key: "hqCartonNo45",
				required: false,
				props: {
					placeholder: this.$t('fbb.inbound.more_containersplit',{defaultValue:'多个集装箱号,分割'})
				}
			}] : []), {
				label: this.$t('global.common.notes',{defaultValue:'备注'}),
				tag: "vTextarea",
				key: "shipmentRemark",
				required: false,
			}, {
				label: this.$t('fbb.inbound.date_warehouse',{defaultValue:'到仓日期'}),
				key: "actualArriveTime",
				query: true,
				required: false,
				show: !this.isEdit,
			}, {
				label: this.$t('fbb.inbound.arrival_date',{defaultValue:'到港日期'}),
				key: "arrivePortDate",
				query: true,
				required: false,
				show: !this.isEdit,
			}]
		},


	},
	methods: {
		async handleConfirmModal() {
			if (this.needBox && !this.hasBoxData) {
				this.$VMessage.warning(this.$t('fbb.inbound.noship_nopacking',{defaultValue:'未装箱不能发货！'}))
				return
			}
			const valid = await this.validFormData().catch(err => { })
			if (!valid) return this.modalProps.show = false;;
			if (!this.needBox) {
				this.confirm();
				return
			}
			this.modalProps = {
				show: true,
				title: this.$t('global.common.update_OK',{defaultValue:'确认'}),
				alert: "warning",
				desc: this.$t('fbb.inbound.confirm_updateversion',{defaultValue:'请核对并确认箱标更新为最新版本！'}),
			}
		},
		// 验证formData
		async validFormData() {
			const valid = await this.$refs.formdata.validate();
			if (!valid) return;
			const { hqCartonNo45 = '', hqQuantity45, hqCartonNo40 = '', hqQuantity40, gpCartonNo40 = '', gpQuantity40, gpQuantity20, gpCartonNo20 = '' } = this.formData;
			// const reg = /^[A-Z]{4}\d{7}$/
			const isCarton = (hqCartonNo45 && hqQuantity45 > 0) || (hqCartonNo40 && hqQuantity40 > 0) || (gpCartonNo40 && gpQuantity40 > 0) || (gpCartonNo20 && gpQuantity20 > 0)
			if (this.isCarton && !isCarton) {
				this.$VMessage.warning(this.$t('fbb.inbound.container_fillone',{defaultValue:'集装箱号,至少需要填写一组'}));
				// this.$VMessage.warning("集装箱号必须为4位大写字母加7位数字,至少需要填写一组");
				return;
			}
			return true;
		},
		// 确认发货
		async confirm() {
			// 	const valid = await this.$refs.formdata.validate();
			// if (!valid) return this.modalProps.show = false;
			// const { hqCartonNo45 = '', hqQuantity45, hqCartonNo40 = '', hqQuantity40, gpCartonNo40 = '', gpQuantity40, gpQuantity20, gpCartonNo20 = '' } = this.formData;
			// // const reg = /^[A-Z]{4}\d{7}$/
			// const isCarton = (hqCartonNo45 && hqQuantity45 > 0) || (hqCartonNo40 && hqQuantity40 > 0) || (gpCartonNo40 && gpQuantity40 > 0) || (gpCartonNo20 && gpQuantity20 > 0)
			// if (this.isCarton && !isCarton) {
			// 	this.$VMessage.warning("集装箱号,至少需要填写一组");
			// 	// this.$VMessage.warning("集装箱号必须为4位大写字母加7位数字,至少需要填写一组");
			// 	return;
            // }
            HttpTransferPlanConfirmDelivery(this.formData).then(res => {
                this.$VMessage.success(res.message);
                this.modalProps.show = this.loading = false;
                this.$emit('on-update');
                this.cancel();
            }).catch(err => {
                this.modalProps.show = this.loading = false;
                this.$VMessage.error(err.message);
            })

		},
		getPackageList() {
			if (!this.isEdit) return;
			HttpPackageList({ page: 1, rows: 1, sidx: 'id', sord: 'desc', id: this.formData.ids }).then(res => {
				const content = (res.data || {}).content || []
				this.hasBoxData = !!content.length
			}).catch(err => {
				this.hasBoxData = false;
			})
		},
		cancel() {
            this.$emit('on-cancel')
            this.$emit('on-close')
		},

	}
};
</script>
